import * as React from 'react'
import { useSelector } from 'react-redux'
import { selectReservation } from '@store/selectors/reservation-selectors'
import { SubscriptionWithBenefitCodeLabel } from '@components/labels/subscription-with-benefit/subscription-with-benefit-code-label'

export const LocalSelectionMapApartmentsListLabels = (): JSX.Element => {
  const { promocode } = useSelector(selectReservation)

  return (
    <div className="d-flex justify-content-center justify-content-lg-start mt-3 mb-2 mb-lg-0 mt-lg-0">
      {promocode && <SubscriptionWithBenefitCodeLabel className="mt-lg-n5 pb-lg-4" />}
    </div>
  )
}
